document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initGaleriaProducto();
  initSelectorVariantes();
  initVideoFondo();
  initBarraFija();
});

function initBarraFija() {
  var barra = document.querySelector('[data-al-barra-fija]');
  var botonReal = document.querySelector('[data-al-boton-comprar]');
  if (!barra || !botonReal) return;

  var botonIr = barra.querySelector('[data-al-ir-a-comprar]');
  if (botonIr) {
    botonIr.addEventListener('click', function () {
      botonReal.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      barra.classList.toggle('al-visible', !entry.isIntersecting);
    });
  }, { threshold: 0 });
  observer.observe(botonReal);
}

function initVideoFondo() {
  var video = document.querySelector('.al-hero-img[autoplay]');
  if (!video) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    video.pause();
    video.removeAttribute('autoplay');
  }
}

function initReveal() {
  var els = document.querySelectorAll('.al-reveal');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('al-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('al-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  els.forEach(function (el) { observer.observe(el); });
}

function initContador() {
  var els = document.querySelectorAll('[data-al-contador]');
  if (!els.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var fin = parseFloat(el.getAttribute('data-al-contador'));
      var decimales = el.getAttribute('data-al-decimales') === '1';
      var duracion = 1400;
      var inicio = null;

      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = decimales ? valor.toFixed(1) : Math.round(valor);
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = decimales ? fin.toFixed(1) : fin;
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });

  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-al-galeria]');
  if (!galeria) return;

  var items = galeria.querySelectorAll('[data-al-media-item]');
  var miniaturas = galeria.querySelectorAll('[data-al-miniatura]');
  if (!items.length || !miniaturas.length) return;

  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var index = mini.getAttribute('data-al-target-index');
      items.forEach(function (item) {
        var esActivo = item.getAttribute('data-al-index') === index;
        item.hidden = !esActivo;
        if (!esActivo) {
          var video = item.querySelector('video');
          if (video) video.pause();
        }
      });
      miniaturas.forEach(function (m) { m.classList.remove('al-miniatura-activa'); });
      mini.classList.add('al-miniatura-activa');
    });
  });
}

function initSelectorVariantes() {
  var forms = document.querySelectorAll('[data-al-form-producto]');
  forms.forEach(function (form) {
    var datosEl = form.querySelector('[data-al-variantes-json]');
    var inputId = form.querySelector('input[name="id"]');
    var botones = form.querySelectorAll('[data-al-opcion-variante]');
    var precioEl = form.closest('[data-al-producto]').querySelector('[data-al-precio]');
    var precioAntesEl = form.closest('[data-al-producto]').querySelector('[data-al-precio-antes]');
    var botonComprar = form.querySelector('[data-al-boton-comprar]');
    if (!datosEl || !botones.length) return;

    var variantes;
    try {
      variantes = JSON.parse(datosEl.textContent);
    } catch (e) {
      return;
    }

    function formatearPrecio(centavos) {
      return (centavos / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00a0€';
    }

    function actualizar(variantId) {
      var variante = variantes.find(function (v) { return String(v.id) === String(variantId); });
      if (!variante) return;
      inputId.value = variante.id;
      if (precioEl) precioEl.textContent = formatearPrecio(variante.price);
      if (precioAntesEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAntesEl.textContent = formatearPrecio(variante.compare_at_price);
          precioAntesEl.hidden = false;
        } else {
          precioAntesEl.hidden = true;
        }
      }
      var ahorroEl = document.querySelector('[data-al-ahorro]');
      if (ahorroEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          ahorroEl.textContent = 'Ahorras ' + formatearPrecio(variante.compare_at_price - variante.price);
          ahorroEl.hidden = false;
        } else {
          ahorroEl.hidden = true;
        }
      }
      if (botonComprar) {
        botonComprar.disabled = !variante.available;
        var textoSpan = botonComprar.querySelector('span');
        var textoNuevo = variante.available
          ? botonComprar.getAttribute('data-al-texto-disponible')
          : botonComprar.getAttribute('data-al-texto-agotado');
        if (textoSpan) {
          textoSpan.textContent = textoNuevo;
        } else {
          botonComprar.textContent = textoNuevo;
        }
      }
      var stockEl = document.querySelector('[data-al-stock]');
      if (stockEl) {
        stockEl.classList.toggle('al-stock--no', !variante.available);
        var st = stockEl.querySelector('[data-al-stock-texto]');
        if (st) st.textContent = variante.available ? 'En stock · envío gratis · entrega en 24-48 h' : 'Agotado por ahora';
      }
      var precioFijaEl = document.querySelector('[data-al-precio-fija]');
      if (precioFijaEl) precioFijaEl.textContent = formatearPrecio(variante.price);
    }

    botones.forEach(function (boton) {
      boton.addEventListener('click', function () {
        botones.forEach(function (b) { b.classList.remove('al-opcion-activa'); });
        boton.classList.add('al-opcion-activa');
        actualizar(boton.getAttribute('data-al-opcion-variante'));
      });
    });
  });
}


/* =====================================================================
   ALBANE v4 — interacciones
   ===================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  initCabeceraScroll();
  initAnadirRapido();
  initDescripcionAcordeon();
  initCantidad();
  initGaleriaMejorada();
  initVolverArriba();
});

function initCabeceraScroll() {
  var marcar = function () { document.body.classList.toggle('al-scrolled', window.scrollY > 8); };
  marcar();
  window.addEventListener('scroll', marcar, { passive: true });
}

function initAnadirRapido() {
  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-al-quick-add]');
    if (!boton || boton.classList.contains('is-loading')) return;
    e.preventDefault();
    var id = boton.getAttribute('data-variant-id');
    var carrito = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript' } };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var datos = new FormData();
    datos.append('id', id);
    datos.append('quantity', 1);
    if (carrito && carrito.getSectionsToRender) {
      datos.append('sections', carrito.getSectionsToRender().map(function (s) { return s.id; }));
      datos.append('sections_url', window.location.pathname);
      if (carrito.setActiveElement) carrito.setActiveElement(boton);
    }
    config.body = datos;
    boton.classList.add('is-loading');
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, config)
      .then(function (r) { return r.json(); })
      .then(function (estado) {
        boton.classList.remove('is-loading');
        if (estado.status) { window.location.href = '/cart'; return; }
        var ok = boton.querySelector('.al-card__boton-ok');
        if (!ok) { ok = document.createElement('span'); ok.className = 'al-card__boton-ok'; ok.setAttribute('role', 'status'); ok.textContent = '✓ Añadido'; boton.appendChild(ok); }
        void ok.offsetWidth; boton.classList.add('is-ok');
        var txt = boton.querySelector('.al-card__boton-txt'); var antes = txt ? txt.textContent : ''; if (txt) txt.textContent = '✓ Añadido';
        setTimeout(function () { boton.classList.remove('is-ok'); if (txt) txt.textContent = antes; }, 2200);
        if (carrito && carrito.renderContents) carrito.renderContents(estado);
        else window.location.href = '/cart';
      })
      .catch(function () { boton.classList.remove('is-loading'); window.location.href = '/cart'; });
  });
}

function initDescripcionAcordeon() {
  var desc = document.querySelector('.al-descripcion');
  if (!desc || desc.getAttribute('data-al-acordeon')) return;
  var hijos = Array.prototype.slice.call(desc.children);
  if (!hijos.some(function (n) { return /^H[23]$/.test(n.tagName); })) return;
  desc.setAttribute('data-al-acordeon', '1');

  var intro = document.createElement('div');
  var acordeon = document.createElement('div');
  acordeon.className = 'al-acordeon';
  var actual = null, cuerpo = null, primero = true;

  hijos.forEach(function (nodo) {
    if (/^H[23]$/.test(nodo.tagName)) {
      actual = document.createElement('details');
      if (primero) { actual.open = true; primero = false; }
      var resumen = document.createElement('summary');
      var texto = document.createElement('span');
      texto.textContent = nodo.textContent;
      var mas = document.createElement('span');
      mas.className = 'al-mas';
      mas.setAttribute('aria-hidden', 'true');
      resumen.appendChild(texto);
      resumen.appendChild(mas);
      cuerpo = document.createElement('div');
      cuerpo.className = 'al-acordeon-cuerpo';
      actual.appendChild(resumen);
      actual.appendChild(cuerpo);
      acordeon.appendChild(actual);
    } else if (cuerpo) {
      cuerpo.appendChild(nodo);
    } else {
      intro.appendChild(nodo);
    }
  });
  desc.innerHTML = '';
  if (intro.childNodes.length) desc.appendChild(intro);
  desc.appendChild(acordeon);

  // Solo una abierta a la vez en móvil
  acordeon.addEventListener('toggle', function (e) {
    if (!e.target.open || !window.matchMedia('(max-width: 749px)').matches) return;
    acordeon.querySelectorAll('details[open]').forEach(function (d) { if (d !== e.target) d.open = false; });
  }, true);
}

function initCantidad() {
  var form = document.querySelector('[data-al-form-producto]');
  if (!form || form.querySelector('.al-qty')) return;
  var boton = form.querySelector('[data-al-boton-comprar]');
  if (!boton) return;
  var fila = document.createElement('div');
  fila.className = 'al-qty-fila';
  fila.innerHTML =
    '<span class="al-qty-etiqueta">Cantidad</span>' +
    '<div class="al-qty"><button type="button" data-al-menos aria-label="Quitar una unidad">−</button>' +
    '<input type="number" name="quantity" value="1" min="1" max="20" inputmode="numeric" aria-label="Cantidad">' +
    '<button type="button" data-al-mas aria-label="Añadir una unidad">+</button></div>';
  boton.parentNode.insertBefore(fila, boton);
  var input = fila.querySelector('input');
  var ajustar = function (d) {
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, Math.min(20, v + d));
  };
  fila.querySelector('[data-al-menos]').addEventListener('click', function () { ajustar(-1); });
  fila.querySelector('[data-al-mas]').addEventListener('click', function () { ajustar(1); });
  input.addEventListener('change', function () { ajustar(0); });
}

function initGaleriaMejorada() {
  var galeria = document.querySelector('[data-al-galeria]');
  if (!galeria) return;
  var items = Array.prototype.slice.call(galeria.querySelectorAll('[data-al-media-item]'));
  var minis = galeria.querySelectorAll('[data-al-miniatura]');
  if (!items.length) return;
  var caja = items[0].parentNode;
  caja.classList.add('al-galeria-principal');

  var indiceActual = function () {
    for (var i = 0; i < items.length; i++) if (!items[i].hidden) return i;
    return 0;
  };
  var ir = function (i) {
    var n = (i + items.length) % items.length;
    var mini = galeria.querySelector('[data-al-target-index="' + n + '"]');
    if (mini) mini.click();
    actualizarContador();
  };
  var contador;
  var actualizarContador = function () { if (contador) contador.textContent = (indiceActual() + 1) + ' / ' + items.length; };

  if (items.length > 1) {
    var svgPrev = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
    var svgNext = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
    var prev = document.createElement('button'); prev.type = 'button'; prev.className = 'al-galeria-flecha al-galeria-flecha--prev'; prev.setAttribute('aria-label', 'Foto anterior'); prev.innerHTML = svgPrev;
    var next = document.createElement('button'); next.type = 'button'; next.className = 'al-galeria-flecha al-galeria-flecha--next'; next.setAttribute('aria-label', 'Foto siguiente'); next.innerHTML = svgNext;
    contador = document.createElement('span'); contador.className = 'al-galeria-contador'; contador.setAttribute('aria-hidden', 'true');
    caja.appendChild(prev); caja.appendChild(next); caja.appendChild(contador);
    prev.addEventListener('click', function (e) { e.stopPropagation(); ir(indiceActual() - 1); });
    next.addEventListener('click', function (e) { e.stopPropagation(); ir(indiceActual() + 1); });
    minis.forEach(function (m) { m.addEventListener('click', function () { setTimeout(actualizarContador, 0); }); });
    actualizarContador();

    var x0 = null;
    caja.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].clientX; }, { passive: true });
    caja.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 48) ir(indiceActual() + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
  }

  // Ampliar foto
  var lb = null;
  var cerrar = function () {
    if (!lb) return;
    lb.classList.remove('is-open');
    var el = lb; lb = null;
    document.removeEventListener('keydown', teclas);
    setTimeout(function () { el.remove(); }, 300);
  };
  var teclas = function (e) {
    if (e.key === 'Escape') cerrar();
    if (e.key === 'ArrowRight' && items.length > 1) { ir(indiceActual() + 1); pintar(); }
    if (e.key === 'ArrowLeft' && items.length > 1) { ir(indiceActual() - 1); pintar(); }
  };
  var pintar = function () {
    if (!lb) return;
    var img = items[indiceActual()].querySelector('img');
    var destino = lb.querySelector('img');
    if (img && destino) { destino.src = img.currentSrc || img.src; destino.alt = img.alt || ''; }
  };
  caja.addEventListener('click', function (e) {
    var img = e.target.closest('img');
    if (!img || e.target.closest('.al-galeria-flecha')) return;
    lb = document.createElement('div');
    lb.className = 'al-lightbox'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Foto ampliada');
    lb.innerHTML = '<img alt=""><button type="button" class="al-lb-cerrar" aria-label="Cerrar">×</button>' +
      (items.length > 1 ? '<button type="button" class="al-lb-prev" aria-label="Anterior">‹</button><button type="button" class="al-lb-next" aria-label="Siguiente">›</button>' : '');
    document.body.appendChild(lb);
    pintar();
    var elLb = lb;
    requestAnimationFrame(function () { if (elLb) elLb.classList.add('is-open'); });
    lb.addEventListener('click', function (ev) {
      if (ev.target.closest('.al-lb-prev')) { ir(indiceActual() - 1); pintar(); return; }
      if (ev.target.closest('.al-lb-next')) { ir(indiceActual() + 1); pintar(); return; }
      if (ev.target.tagName !== 'IMG') cerrar();
    });
    document.addEventListener('keydown', teclas);
  });
}

function initVolverArriba() {
  var b = document.createElement('button');
  b.type = 'button'; b.className = 'al-arriba'; b.setAttribute('aria-label', 'Volver arriba');
  b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 15l-6-6-6 6"/></svg>';
  document.body.appendChild(b);
  var mostrar = function () { b.classList.toggle('is-visible', window.scrollY > 900); };
  window.addEventListener('scroll', mostrar, { passive: true });
  mostrar();
  b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
}


document.addEventListener('DOMContentLoaded', function () {
  var img = document.querySelector('.al-hero2__arco img');
  if (!img || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = Math.min(window.scrollY, 700);
      img.style.transform = 'translateY(' + (y * 0.06) + 'px) scale(1.06)';
      ticking = false;
    });
  }, { passive: true });
});


/* =====================================================================
   ALBANE v4 — Banner, efectos, vista rápida, vistos recientemente
   ===================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  initSlider();
  initBarraProgreso();
  initEfectosTarjetas();
  initBotonesMagneticos();
  initVistaRapida();
  initRecientes();
  initPrecarga();
});

/* ---------- Carrusel del banner ---------- */
function initSlider() {
  var cont = document.querySelector('[data-al-slider]');
  if (!cont || cont.getAttribute('data-listo')) return;
  cont.setAttribute('data-listo', '1');
  var slides = Array.prototype.slice.call(cont.querySelectorAll('[data-al-slide]'));
  var puntos = Array.prototype.slice.call(cont.querySelectorAll('[data-al-punto]'));
  var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var intervalo = (parseFloat(cont.getAttribute('data-intervalo')) || 7) * 1000;
  var auto = cont.getAttribute('data-autoplay') === 'true' && slides.length > 1 && !reducir;
  var actual = 0, pausadoUsuario = false, pausadoHover = false, t0 = performance.now(), transcurrido = 0, raf = null;

  // Dividir títulos en palabras para la animación
  cont.querySelectorAll('[data-al-dividir]').forEach(function (h) {
    var texto = h.textContent.trim().split(/\s+/);
    h.innerHTML = '';
    texto.forEach(function (w, i) {
      var cap = document.createElement('span'); cap.className = 'al-pal'; cap.setAttribute('aria-hidden', 'true');
      var s = document.createElement('span'); s.textContent = w; s.style.setProperty('--i', i);
      cap.appendChild(s); h.appendChild(cap);
      if (i < texto.length - 1) h.appendChild(document.createTextNode(' '));
    });
  });

  function marcarClaro() {
    var s = slides[actual];
    cont.classList.toggle('is-sobre-claro', s.classList.contains('al-slide--dividida') && !s.classList.contains('al-slide--claro'));
  }
  function ir(n) {
    n = (n + slides.length) % slides.length;
    slides[actual].classList.remove('is-activa'); slides[actual].setAttribute('aria-hidden', 'true');
    if (puntos[actual]) { puntos[actual].classList.remove('is-activo'); puntos[actual].style.removeProperty('--p'); }
    actual = n;
    slides[actual].classList.add('is-activa'); slides[actual].removeAttribute('aria-hidden');
    if (puntos[actual]) puntos[actual].classList.add('is-activo');
    transcurrido = 0; t0 = performance.now(); marcarClaro();
  }
  function tick(ahora) {
    var parado = pausadoUsuario || pausadoHover || document.hidden;
    if (parado) { t0 = ahora - transcurrido; }
    else {
      transcurrido = ahora - t0;
      var p = Math.min(transcurrido / intervalo, 1);
      if (puntos[actual]) puntos[actual].style.setProperty('--p', p);
      if (p >= 1) ir(actual + 1);
    }
    raf = requestAnimationFrame(tick);
  }
  var prev = cont.querySelector('[data-al-prev]'), next = cont.querySelector('[data-al-next]'), pausa = cont.querySelector('[data-al-pausa]');
  if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
  if (next) next.addEventListener('click', function () { ir(actual + 1); });
  puntos.forEach(function (p) { p.addEventListener('click', function () { ir(parseInt(p.getAttribute('data-al-punto'), 10)); }); });
  if (pausa) pausa.addEventListener('click', function () {
    pausadoUsuario = !pausadoUsuario; pausa.setAttribute('aria-pressed', pausadoUsuario ? 'true' : 'false');
  });
  cont.addEventListener('mouseenter', function () { pausadoHover = true; });
  cont.addEventListener('mouseleave', function () { pausadoHover = false; });
  cont.addEventListener('focusin', function () { pausadoHover = true; });
  cont.addEventListener('focusout', function () { pausadoHover = false; });
  cont.setAttribute('tabindex', '0');
  cont.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') ir(actual + 1);
    if (e.key === 'ArrowLeft') ir(actual - 1);
  });
  var x0 = null;
  cont.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].clientX; }, { passive: true });
  cont.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 50) ir(actual + (dx < 0 ? 1 : -1));
    x0 = null;
  }, { passive: true });
  marcarClaro();
  if (auto) raf = requestAnimationFrame(tick);
}

/* ---------- Barra de progreso de lectura ---------- */
function initBarraProgreso() {
  var b = document.createElement('div'); b.className = 'al-progreso'; b.setAttribute('aria-hidden', 'true');
  document.body.appendChild(b);
  var ticking = false;
  function pintar() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    b.style.transform = 'scaleX(' + (h > 0 ? Math.min(window.scrollY / h, 1) : 0) + ')';
    ticking = false;
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(pintar); } }, { passive: true });
  pintar();
}

/* ---------- Brillo y ligera inclinación en tarjetas ---------- */
function initEfectosTarjetas() {
  if (window.matchMedia('(hover: none)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.addEventListener('mousemove', function (e) {
    var m = e.target.closest && e.target.closest('.al-card__media, .al-cat__media');
    if (!m) return;
    var r = m.getBoundingClientRect();
    var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
    m.style.setProperty('--mx', (x * 100) + '%'); m.style.setProperty('--my', (y * 100) + '%');
    m.style.transform = 'translateY(-5px) perspective(900px) rotateX(' + ((0.5 - y) * 4) + 'deg) rotateY(' + ((x - 0.5) * 5) + 'deg)';
  });
  document.addEventListener('mouseout', function (e) {
    var m = e.target.closest && e.target.closest('.al-card__media, .al-cat__media');
    if (m && !m.contains(e.relatedTarget)) m.style.transform = '';
  });
}

/* ---------- Botones magnéticos ---------- */
function initBotonesMagneticos() {
  if (window.matchMedia('(hover: none)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.addEventListener('mousemove', function (e) {
    var b = e.target.closest && e.target.closest('.al-boton--magnetico');
    if (!b) return;
    var r = b.getBoundingClientRect();
    b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.14) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.22) + 'px)';
  });
  document.addEventListener('mouseout', function (e) {
    var b = e.target.closest && e.target.closest('.al-boton--magnetico');
    if (b) b.style.transform = '';
  });
}

/* ---------- Precarga de páginas al pasar el ratón ---------- */
function initPrecarga() {
  if (!('requestIdleCallback' in window) || (navigator.connection && navigator.connection.saveData)) return;
  var hechos = {};
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="/products/"], a[href^="/collections/"]');
    if (!a || hechos[a.href] || a.target === '_blank') return;
    hechos[a.href] = true;
    var l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; document.head.appendChild(l);
  }, { passive: true });
}

/* ---------- Vistos recientemente ---------- */
function eur(c) { return (c / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
function initRecientes() {
  var handleActual = document.querySelector('[data-al-handle-producto]');
  var clave = 'albane_recientes';
  var lista = [];
  try { lista = JSON.parse(localStorage.getItem(clave) || '[]'); } catch (e) { lista = []; }
  if (handleActual) {
    var h = handleActual.getAttribute('data-al-handle-producto');
    lista = [h].concat(lista.filter(function (x) { return x !== h; })).slice(0, 12);
    try { localStorage.setItem(clave, JSON.stringify(lista)); } catch (e) {}
  }
  var cont = document.querySelector('[data-al-recientes]');
  if (!cont) return;
  var max = parseInt(cont.getAttribute('data-max'), 10) || 4;
  var mostrar = lista.filter(function (x) { return !handleActual || x !== handleActual.getAttribute('data-al-handle-producto'); }).slice(0, max);
  if (!mostrar.length) return;
  Promise.all(mostrar.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
    .then(function (ps) {
      ps = ps.filter(Boolean);
      if (!ps.length) return;
      var grid = cont.querySelector('[data-al-recientes-grid]');
      var tit = cont.querySelector('[data-al-recientes-titulo]');
      if (tit) tit.innerHTML = '<span class="al-etiqueta" style="color:#a9544a;">' + (cont.getAttribute('data-eyebrow') || '') + '</span><h2 class="al-titulo" style="font-size:' + (cont.getAttribute('data-size') || 34) + 'px; margin-top:10px;">' + (cont.getAttribute('data-titulo') || '') + '</h2>';
      grid.innerHTML = ps.map(function (p) {
        var img = (p.featured_image || '').replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2');
        return '<a class="al-rec" href="' + p.url + '"><div class="al-rec__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="600" height="600">' : '') + '</div><p class="al-rec__tit">' + p.title.replace(/</g, '&lt;') + '</p><span class="al-rec__precio">' + eur(p.price) + '</span></a>';
      }).join('');
      cont.classList.add('is-lista');
    });
}

/* ---------- Vista rápida ---------- */
function initVistaRapida() {
  var modal = null, datos = null, varianteSel = null;
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function imgTam(u, t) { return (u || '').replace(/(\.[a-zA-Z]+)(\?|$)/, '_' + t + 'x$1$2'); }
  function cerrar() {
    if (!modal) return;
    var m = modal; modal = null; m.classList.remove('is-open');
    document.removeEventListener('keydown', teclas); document.body.style.overflow = '';
    setTimeout(function () { m.remove(); }, 320);
  }
  function teclas(e) { if (e.key === 'Escape') cerrar(); }
  function pintarPrecio() {
    var v = varianteSel, el = modal.querySelector('.al-qv__precio');
    el.innerHTML = '<span>' + eur(v.price) + '</span>' + (v.compare_at_price > v.price ? '<s>' + eur(v.compare_at_price) + '</s>' : '');
    var b = modal.querySelector('[data-qv-add]');
    b.disabled = !v.available; b.querySelector('span').textContent = v.available ? 'Añadir al carrito' : 'Agotado';
  }
  function abrir(handle) {
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      datos = p; varianteSel = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      var imgs = (p.images && p.images.length) ? p.images : [p.featured_image];
      var tmp = document.createElement('div'); tmp.innerHTML = p.description || ''; var pp = tmp.querySelector('p'); var desc = ((pp ? pp.textContent : tmp.textContent) || '').replace(/\s+/g, ' ').trim();
      modal = document.createElement('div'); modal.className = 'al-qv'; modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', p.title);
      modal.innerHTML = '<div class="al-qv__caja"><button type="button" class="al-qv__cerrar" aria-label="Cerrar" data-qv-cerrar>×</button>' +
        '<div class="al-qv__media"><img src="' + esc(imgTam(imgs[0], 900)) + '" alt="' + esc(p.title) + '" data-qv-img>' +
        (imgs.length > 1 ? '<div class="al-qv__minis">' + imgs.slice(0, 8).map(function (u, i) { return '<button type="button" class="al-qv__mini' + (i === 0 ? ' is-activa' : '') + '" data-qv-mini="' + i + '"><img src="' + esc(imgTam(u, 120)) + '" alt=""></button>'; }).join('') + '</div>' : '') + '</div>' +
        '<div class="al-qv__info"><h3 class="al-qv__titulo">' + esc(p.title) + '</h3><div class="al-qv__precio"></div>' +
        '<p class="al-qv__desc">' + esc(desc) + '</p>' +
        (p.variants.length > 1 ? '<div class="al-qv__vars">' + p.variants.map(function (v, i) { return '<button type="button" class="al-qv__var' + (v.id === varianteSel.id ? ' is-activa' : '') + '" data-qv-var="' + i + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</button>'; }).join('') + '</div>' : '') +
        '<div class="al-qv__acciones"><div class="al-qty"><button type="button" data-qv-menos aria-label="Quitar una unidad">−</button><input type="number" value="1" min="1" max="20" aria-label="Cantidad" data-qv-cant><button type="button" data-qv-mas aria-label="Añadir una unidad">+</button></div>' +
        '<button type="button" class="al-boton" data-qv-add><span>Añadir al carrito</span></button></div>' +
        '<p class="al-qv__aviso" aria-live="polite"></p><a class="al-qv__ficha" href="' + esc(p.url) + '">Ver ficha completa →</a></div></div>';
      document.body.appendChild(modal); document.body.style.overflow = 'hidden';
      pintarPrecio();
      requestAnimationFrame(function () { if (modal) modal.classList.add('is-open'); });
      document.addEventListener('keydown', teclas);
      modal.addEventListener('click', function (e) {
        if (e.target === modal || e.target.closest('[data-qv-cerrar]')) return cerrar();
        var mini = e.target.closest('[data-qv-mini]');
        if (mini) {
          modal.querySelector('[data-qv-img]').src = imgTam(imgs[mini.getAttribute('data-qv-mini')], 900);
          modal.querySelectorAll('.al-qv__mini').forEach(function (m) { m.classList.toggle('is-activa', m === mini); });
        }
        var vb = e.target.closest('[data-qv-var]');
        if (vb) {
          varianteSel = datos.variants[vb.getAttribute('data-qv-var')];
          modal.querySelectorAll('.al-qv__var').forEach(function (m) { m.classList.toggle('is-activa', m === vb); });
          pintarPrecio();
        }
        var cant = modal.querySelector('[data-qv-cant]');
        if (e.target.closest('[data-qv-mas]')) cant.value = Math.min(20, (parseInt(cant.value, 10) || 1) + 1);
        if (e.target.closest('[data-qv-menos]')) cant.value = Math.max(1, (parseInt(cant.value, 10) || 1) - 1);
        if (e.target.closest('[data-qv-add]')) anadir();
      });
    });
  }
  function anadir() {
    var b = modal.querySelector('[data-qv-add]'), aviso = modal.querySelector('.al-qv__aviso');
    if (b.disabled) return;
    var carrito = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript' } };
    config.headers['X-Requested-With'] = 'XMLHttpRequest'; delete config.headers['Content-Type'];
    var fd = new FormData(); fd.append('id', varianteSel.id); fd.append('quantity', modal.querySelector('[data-qv-cant]').value || 1);
    if (carrito && carrito.getSectionsToRender) { fd.append('sections', carrito.getSectionsToRender().map(function (s) { return s.id; })); fd.append('sections_url', window.location.pathname); }
    config.body = fd; b.disabled = true; aviso.textContent = 'Añadiendo…';
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config).then(function (r) { return r.json(); }).then(function (estado) {
      if (estado.status) { aviso.textContent = estado.description || 'No se ha podido añadir.'; b.disabled = false; return; }
      aviso.textContent = '¡Añadido al carrito!';
      setTimeout(function () { cerrar(); if (carrito && carrito.renderContents) carrito.renderContents(estado); else window.location.href = '/cart'; }, 450);
    }).catch(function () { window.location.href = '/cart'; });
  }
  document.addEventListener('click', function (e) {
    var v = e.target.closest('[data-al-vista]');
    if (!v) return;
    e.preventDefault(); abrir(v.getAttribute('data-handle'));
  });
}


/* ---------- Botones del banner: onda y desplazamiento suave a anclas ---------- */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('.al-slide__botones .al-boton');
  if (!b) return;
  var r = b.getBoundingClientRect(), t = Math.max(r.width, r.height) * 2;
  var o = document.createElement('span'); o.className = 'al-onda';
  o.style.cssText = 'width:' + t + 'px;height:' + t + 'px;left:' + (e.clientX - r.left - t / 2) + 'px;top:' + (e.clientY - r.top - t / 2) + 'px';
  b.appendChild(o); setTimeout(function () { o.remove(); }, 750);
  var href = b.getAttribute('href') || '';
  if (href.charAt(0) === '#' && href.length > 1) {
    var dest = document.getElementById(href.slice(1));
    if (dest) { e.preventDefault(); alDesplazarA(dest); try { history.replaceState(null, '', href); } catch (x) {} }
  }
});


/* Desplazamiento suave propio (funciona aunque el navegador no lo haga solo) */
function alDesplazarA(el) {
  var cab = document.querySelector('.section-header');
  var margen = (cab ? cab.getBoundingClientRect().height : 90) + 12;
  var destino = Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - margen);
  var inicio = window.pageYOffset, delta = destino - inicio;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || Math.abs(delta) < 4) { window.scrollTo(0, destino); return; }
  var dur = Math.min(1100, 450 + Math.abs(delta) * 0.25), t0 = null;
  var suave = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  document.documentElement.style.scrollBehavior = 'auto';
  function paso(ts) {
    if (t0 === null) t0 = ts;
    var p = Math.min((ts - t0) / dur, 1);
    window.scrollTo(0, inicio + delta * suave(p));
    if (p < 1) requestAnimationFrame(paso); else document.documentElement.style.scrollBehavior = '';
  }
  requestAnimationFrame(paso);
  setTimeout(function () { if (Math.abs(window.pageYOffset - destino) > 4) window.scrollTo(0, destino); document.documentElement.style.scrollBehavior = ''; }, dur + 250);
}


/* ---------- Ampliar fotos de opiniones ---------- */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-al-zoom]');
  if (!b) return;
  var lb = document.createElement('div');
  lb.className = 'al-lightbox'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Foto ampliada');
  var alt = (b.querySelector('img') || {}).alt || '';
  lb.innerHTML = '<img alt="' + alt.replace(/"/g, '&quot;') + '" src="' + b.getAttribute('data-src') + '"><button type="button" class="al-lb-cerrar" aria-label="Cerrar">×</button>';
  document.body.appendChild(lb);
  requestAnimationFrame(function () { lb.classList.add('is-open'); });
  var cerrar = function () { lb.classList.remove('is-open'); document.removeEventListener('keydown', tecla); setTimeout(function () { lb.remove(); }, 300); };
  var tecla = function (ev) { if (ev.key === 'Escape') cerrar(); };
  document.addEventListener('keydown', tecla);
  lb.addEventListener('click', function (ev) { if (ev.target.tagName !== 'IMG') cerrar(); });
});
